import { useEffect, useRef, useState } from "react";
import { useRequestFinished } from "../../../common/hooks";
import { connect } from "react-redux";
import { Avatar } from "primereact/avatar";
import { useIntl } from "react-intl";
import { OverlayPanel } from "primereact/overlaypanel";
import { Tooltip } from "primereact/tooltip";
import { useLocation, useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import EdexLogo from "../../../../assets/images/Ed_EX_logo_plain.png";
import * as Displayhelper from "../../../../helpers/DisplayHelper";
import {
  activeChildMenu,
  activeParentMenu,
  isOnMenu,
} from "../../../../helpers/NavigationHelper";
import { logout } from "../../../../store/slices/authSlice";
import { resetAll } from "../../../../store/slices/baseSlice";
import { setDashboard } from "../../../../store/slices/selfSlice";
import {
  resetNavigation,
  changeNavigation,
  toggleSideBar,
} from "../../../../store/slices/navigationSlice";
import { MenuConstants, RouteConstants } from "../../../../constants";
import Form from "../../../common/form";
import ChangePasswordForm from "./ChangpasswordForm";
import {
  changePasswordRequest,
  setPasswordRequest,
} from "../../../../store/slices/selfSlice";

import { markSignedOut } from "../../../../helpers/SsoHelper";
import "./header.scss";
import SetpasswordForm from "./SetpasswordForm";
import useMobileView from "../../../common/hooks/useMobileView";

export const Header = ({
  changeNavigation,
  changePasswordRequest,
  childMenu,
  dashboard,
  enterprise,
  isRoleSwitching,
  logout,
  parentMenu,
  resetAll,
  resetNavigation,
  setDashboard,
  user,
  action,
  requesting,
  error,
  setPasswordRequest,
  toggleSidebar,
  isMobileSidebarOpen,
}) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const op = useRef(null);
  const { isMobile } = useMobileView();

  const [isProfileMenuVisible, setIsProfileMenuVisible] = useState(false);
  const [isChangePasswordDialogVisible, setChangePasswordDialogVisible] =
    useState(false);

  const [isSetPasswordDialogVisible, setIsSetPasswordDialigVisible] = useState(
    user?.hasSystemPassword || false
  );

  let logo = EdexLogo;
  if (enterprise && enterprise.logo) {
    logo = enterprise.logo;
  }

  let menus = MenuConstants.ADMIN_MENU_ITEMS;
  if (enterprise && dashboard === "admin") {
    menus = MenuConstants.ENTERPRISE_ADMIN_MENU_ITEMS;
  } else if (enterprise && dashboard === "learner") {
    menus = MenuConstants.LEARNER_MENU_ITEMS;
  }

  // Follows the page shown, so a link into another section shows that
  // section's menu row (see NavigationHelper).
  const selectedParent = menus.find(
    (menu) => menu.id === activeParentMenu(menus, pathname, parentMenu)
  );
  const activeChild = activeChildMenu(selectedParent, pathname, childMenu);
  const hasTertiaryMenu =
    selectedParent?.childrens?.filter((menu) => menu?.childrens?.length > 0)
      ?.length > 0;

  useEffect(() => {
    if (!isRoleSwitching && dashboard === "admin") {
      setDashboard("learner");
    }
  }, [isRoleSwitching, dashboard, setDashboard]);

  useEffect(() => {
    if (
      user?.hasSystemPassword &&
      isSetPasswordDialogVisible !== user?.hasSystemPassword
    ) {
      setIsSetPasswordDialigVisible(true);
    }
  }, [user?.hasSystemPassword]);

  // Only a change answered while the header is shown: the persisted store
  // can hold a settled password change when it mounts (review M1).
  const requestFinished = useRequestFinished(requesting);
  useEffect(() => {
    if (
      (action === "change-password-request" ||
        action === "set-password-request") &&
      requestFinished &&
      !error
    ) {
      handleLogout();
    }
  }, [error, action, requestFinished]);

  useEffect(() => {
    if (!isMobile && isMobileSidebarOpen) {
      toggleSidebar();
    }
  }, [isMobile]);

  const handleLogout = () => {
    markSignedOut();
    logout();
    resetAll();
  };

  const handleSetDasboard = () => {
    resetNavigation();
    setDashboard(dashboard === "learner" ? "admin" : "learner");
  };

  const handleChildMenu = (menu) => {
    if (isOnMenu(menu, pathname)) {
      return;
    }
    changeNavigation({
      child: menu.id,
    });
    navigate(menu.to);
  };

  const handleChangePassword = (values) => {
    changePasswordRequest({
      currentPassword: values.currentPassword,
      newPassword: values.newPassword,
    });
    setChangePasswordDialogVisible(false);
  };

  const handleSetPassword = (values) => {
    setPasswordRequest({
      newPassword: values.newPassword,
    });
    setIsSetPasswordDialigVisible(false);
  };

  return (
    <div className="edexlms-header flex align-items-center justify-content-between">
      <div className="edexlms-header-logo flex align-items-center gap-3 ">
        {((!enterprise || !enterprise.logo) && (
          <img
            src={EdexLogo}
            alt="Logo"
            className="logo flex-order-2 md:flex-order-1"
          />
        )) || (
          <img
            src={`${new URL(logo, process.env.REACT_APP_URL).toString()}`}
            alt="Logo"
            className="logo flex-order-2 md:flex-order-1"
          />
        )}
        <span
          data-testid="menu-toggle"
          className="block md:hidden flex-order-1 pi pi-bars edexlms-header-menu-bars cursor-pointer"
          onClick={toggleSidebar}
        />
      </div>
      <div className="edexlms-header-tertiary-nav">
        {(hasTertiaryMenu &&
          !isMobile &&
          selectedParent.childrens.map((menu) => {
            return (
              <div
                onClick={() => handleChildMenu(menu)}
                key={menu.id}
                className={`edexlms-header-tertiary-nav-item${
                  menu.id === activeChild ? " active" : ""
                }`}
              >
                <span>{intl.formatMessage({ id: menu.label })}</span>
              </div>
            );
          })) ||
          null}
      </div>
      <div className="edexlms-header-profile-nav">
        {(enterprise && enterprise.logo && isRoleSwitching && (
          <>
            {(dashboard === "learner" && (
              <>
                <Tooltip position="left" target=".switch-dashboard" />
                <i
                  data-pr-tooltip={intl.formatMessage({
                    id: "switching_role_admin",
                    defaultMessage: "Switching Role",
                  })}
                  onClick={handleSetDasboard}
                  data-testid="switch-dashboard"
                  className={`switch-dashboard pi ${
                    dashboard === "learner" ? "pi-cog" : "pi-book"
                  }`}
                  style={{ fontSize: "2rem", cursor: "pointer" }}
                ></i>
              </>
            )) ||
              null}
            {(dashboard !== "learner" && (
              <>
                <Tooltip position="left" target=".switch-dashboard" />
                <i
                  data-pr-tooltip={intl.formatMessage({
                    id: "switching_role_learner",
                    defaultMessage: "Switching Role",
                  })}
                  onClick={handleSetDasboard}
                  data-testid="switch-dashboard"
                  className={`switch-dashboard pi ${
                    dashboard === "learner" ? "pi-cog" : "pi-book"
                  }`}
                  style={{ fontSize: "2rem", cursor: "pointer" }}
                ></i>
              </>
            )) ||
              null}
          </>
        )) ||
          null}
        <div
          data-testid="profile-menu"
          className="edexlms-header-profile"
          onClick={(e) => {
            setIsProfileMenuVisible(!isProfileMenuVisible);
            op.current.toggle(e);
          }}
        >
          <Avatar
            label={Displayhelper.getUserShortName(
              user?.details?.name ||
                `${user?.firstName}${
                  user?.lastName ? ` ${user?.lastName}` : ""
                }`
            )}
            size="small"
            shape="circle"
            className="edexlms-header-profile-avatar"
          />
          {(!isProfileMenuVisible && (
            <i className="pi pi-angle-down ml-2"></i>
          )) || <i className="pi pi-angle-up ml-2"></i>}
        </div>
      </div>
      <OverlayPanel
        ref={op}
        onHide={(e) => setIsProfileMenuVisible(false)}
        className="p-0 edexlms-profile-menu-overlay"
      >
        <ul className="edexlms-profile-menu">
          <li
            onClick={(e) => {
              navigate(RouteConstants.APP_ROUTE_PROFILE);
              setIsProfileMenuVisible(false);
              op.current.toggle(e);
              changeNavigation({
                parent: "profile",
              });
            }}
          >
            <span className="pi pi-user mr-2"></span>
            {user?.details?.email || user?.email}
          </li>
          <li
            onClick={(e) => {
              navigate(RouteConstants.APP_ROUTE_PREFERENCES);
              setIsProfileMenuVisible(false);
              op.current.toggle(e);
              changeNavigation({
                parent: "ACCOUNT_PREFERENCES",
              });
            }}
          >
            <span className="pi pi-list mr-2"></span>
            {intl.formatMessage({ id: "account_preferences" })}
          </li>
          <li
            onClick={(e) => {
              setChangePasswordDialogVisible(true);
              setIsProfileMenuVisible(false);
              op.current.toggle(e);
            }}
          >
            <span className="pi pi-key mr-2"></span>
            {intl.formatMessage({ id: "change_password" })}
          </li>
          <li onClick={handleLogout}>
            <span className="pi pi-sign-out mr-2"></span>
            <span>{intl.formatMessage({ id: "logout" })}</span>
          </li>
        </ul>
      </OverlayPanel>
      <Dialog
        style={{ width: "50vw", minWidth: "400px" }}
        visible={isChangePasswordDialogVisible}
        onHide={() => {
          if (!user?.hasSystemPassword) {
            setChangePasswordDialogVisible(false);
          }
        }}
        header={intl.formatMessage({ id: "change_password" })}
      >
        <Form
          submitBtn={{
            label: intl.formatMessage({ id: "change_password" }),
            onClick: (values) => {
              handleChangePassword(values);
            },
          }}
          cancelBtn={{
            label: intl.formatMessage({ id: "cancel" }),
            onClick: () => {
              if (!user?.hasSystemPassword) {
                setChangePasswordDialogVisible(false);
              }
            },
          }}
        >
          <ChangePasswordForm />
        </Form>
      </Dialog>
      <Dialog
        style={{ width: "50vw", minWidth: "400px" }}
        visible={isSetPasswordDialogVisible}
        onHide={() => {
          if (!user?.hasSystemPassword) {
            setIsSetPasswordDialigVisible(false);
          }
        }}
        header={intl.formatMessage({ id: "set_password_message" })}
      >
        <Form
          submitBtn={{
            label: intl.formatMessage({ id: "set_password" }),
            onClick: (values) => {
              handleSetPassword(values);
            },
          }}
        >
          <SetpasswordForm />
        </Form>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state?.self?.user,
  enterprise: state?.global?.enterprise,
  dashboard: state?.self?.dashboard,
  isRoleSwitching: state?.self?.isRoleSwitching,
  parentMenu: state?.navigation?.parent,
  childMenu: state?.navigation?.child,
  action: state?.self?.action,
  requesting: state?.self?.requesting,
  error: state?.self?.error,
  isMobileSidebarOpen: state?.navigation?.isSideBarOpen,
});

const mapDispatchToProps = (dispatch) => ({
  resetAll: () => dispatch(resetAll()),
  logout: () => dispatch(logout()),
  setDashboard: (data) => dispatch(setDashboard(data)),
  resetNavigation: () => dispatch(resetNavigation()),
  changeNavigation: (data) => dispatch(changeNavigation(data)),
  changePasswordRequest: (data) => dispatch(changePasswordRequest(data)),
  setPasswordRequest: (data) => dispatch(setPasswordRequest(data)),
  toggleSidebar: () => dispatch(toggleSideBar()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
